import React from 'react';

import {LoadingOverlay} from '@homeaway/react-loading-overlay';

// LoadingOverlay.whyDidYouRender = true;

import {useComponent} from './hooks';

import './SearchSubmitDetailsButtonField.less';

function SearchSubmitDetailsButtonField() {
    const {
        className,
        Button,
        type,
        label,
        disabled,
        loading,
        onClick
    } = useComponent();

    return (
        <div className={className}>
            <Button
                type={type}
                label={label}
                disabled={disabled}
                onClick={onClick}
            >
                <LoadingOverlay loading={loading}/>
            </Button>
        </div>
    );
}

SearchSubmitDetailsButtonField.whyDidYouRender = true;

export {SearchSubmitDetailsButtonField};
